// https://blog.bitsrc.io/how-to-develop-a-web-component-using-tailwind-a-modern-starter-kit-vite-tailwind-lit-element-4db824b50b23
import { LitElement, unsafeCSS } from 'lit';

import style from './tailwind.global.css?inline';

const tailwindElement = unsafeCSS(style);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const TailwindElement = (style = {}) =>
	class extends LitElement {
		static styles = [tailwindElement, unsafeCSS(style)];
	};
